import request from '@/services/base/request'

export default {
  sendCode: (operation: any) => request(`/codes/${operation}/`, 'post', null),
  loadDocuments: () => request('/documents/', 'get', null),
  acceptDocument: (data: any) => request('/documents/acceptance/', 'post', data),
  acceptPrivateDocument: (data: any) => request('/documents/acceptance/private/', 'post', data)
} as {[key: string]: MethodDecorator}
